import { __decorate } from "tslib";
import { injectable } from 'tsyringe';
import { saveSFCCRefererLink } from '@gn-audio/core/sfcc/utilities/sfcc-referer-link-actions';
import { saveSFCCReferralSourceCode } from '@gn-audio/core/sfcc/utilities/sfcc-referral-source-code-actions';
var SFCCReferralService = /** @class */ (function () {
    function SFCCReferralService() {
    }
    SFCCReferralService.prototype.saveParametersIfAvailable = function () {
        var urlParams = new URLSearchParams(window.location.search);
        var sourceCode = urlParams.get("utm_source" /* Referral.UTMSource */);
        if (sourceCode) {
            saveSFCCReferralSourceCode(sourceCode);
            this.saveReferrerIfAvailable();
        }
    };
    SFCCReferralService.prototype.saveReferrerIfAvailable = function () {
        if (document.referrer) {
            var referrer = new URL(document.referrer);
            if (referrer.origin !== location.origin) {
                saveSFCCRefererLink(document.referrer);
            }
        }
    };
    SFCCReferralService = __decorate([
        injectable()
    ], SFCCReferralService);
    return SFCCReferralService;
}());
export { SFCCReferralService };
